import { useState } from "react";
import { PageHeader, GlassCard, EmptyState, useCrud, ItemDialog, RowActions } from "../_shared";
import { Button } from "@/components/ui/button";
import { Plus, Megaphone } from "lucide-react";

const FIELDS = [
  { key: "text", label: "Announcement text", required: true, placeholder: "e.g. FASTag Issuance" },
  { key: "enabled", label: "Show in scrolling bar", type: "switch" },
];

export default function AnnouncementsManager() {
  const { items, loading, busy, create, update, remove, move } = useCrud("/admin/cms/announcements");
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const openNew = () => { setEditing({ enabled: true }); setOpen(true); };
  const openEdit = (it) => { setEditing(it); setOpen(true); };
  const submit = async (form) => {
    if (editing?.id) await update(editing.id, form); else await create(form);
    setOpen(false);
  };

  return (
    <>
      <PageHeader
        title="Announcement Bar"
        subtitle="The scrolling ticker at the very top of the website. Turn individual items on/off or reorder them."
        actions={<Button onClick={openNew} className="bg-[#0057B8] hover:bg-[#003F87] text-white rounded-full" data-testid="new-announcement-btn"><Plus className="w-4 h-4 mr-1" /> New Item</Button>}
      />
      {loading ? <div className="text-slate-500">Loading…</div> : items.length === 0 ? (
        <EmptyState label="No announcement items yet." action={<Button onClick={openNew}>Add first item</Button>} />
      ) : (
        <div className="space-y-2">
          {items.map((it, i) => (
            <GlassCard key={it.id} className="px-4 py-3 flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-[#F59E0B]/15 text-[#B45309] grid place-items-center shrink-0"><Megaphone className="w-4 h-4" /></div>
              <div className="flex-1 min-w-0 truncate font-medium">{it.text}</div>
              {!it.enabled && <span className="text-[10px] font-semibold bg-slate-200 text-slate-600 px-2 py-0.5 rounded-full">Hidden</span>}
              <RowActions
                onEdit={() => openEdit(it)} onDelete={() => remove(it.id)}
                onUp={() => move(it.id, "up")} onDown={() => move(it.id, "down")}
                canUp={i > 0} canDown={i < items.length - 1}
              />
            </GlassCard>
          ))}
        </div>
      )}
      <ItemDialog
        open={open} onOpenChange={setOpen}
        title={editing?.id ? "Edit Announcement" : "New Announcement"}
        fields={FIELDS}
        initial={editing || { enabled: true }}
        onSubmit={submit}
        submitting={busy}
      />
    </>
  );
}
